import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PostContentObjectDetailDataObject } from 'models/service';

type CreatePostRequestBody = {
  attachments?: Array<{ id: string }>;
  html_content: string;
  program_id: string;
  program_topic_id: string;
  publish_at: string;
  text_content?: string;
  title: string;
  todo_due_date: string;
};

export const createPost = async ({ body }: BodyRequest<CreatePostRequestBody>) =>
  apiClient.post<PostContentObjectDetailDataObject, ApiClientResponse<PostContentObjectDetailDataObject>>(
    routes.posts.create,
    {
      post: body,
    },
  );
